import callApi from 'helpers/callApi';

//callApi({ url:

export const getRevenueSummaryList = (params) => callApi({ url: '/revenue-summaries', query: params });
export const getAllRevenueSummaries = (params) =>
  callApi({
    url: '/revenue-summaries',
    query: {
      ...params,
      limit: 10000,
      page: 1,
    },
  });
export const freeze = (id) => callApi({ url: `/revenue-summaries/${id}/freeze`, method: 'POST' });
export const unfreeze = (id) => callApi({ url: `/revenue-summaries/${id}/unfreeze`, method: 'POST' });
